app.service('localStorage', function () {

	function checkExpire(name) {
		if (window.localStorage.getItem('expiresDates')) {
			let expiresCollection = JSON.parse(window.localStorage.getItem('expiresDates'));
			if (expiresCollection[name] && parseFloat(expiresCollection[name]) < Date.now()) {
				removeItem(name);
				delete expiresCollection[name];
				window.localStorage.setItem('expiresDates', JSON.stringify(expiresCollection));
			}
		}
	}

	function getItem(name) {
		checkExpire(name);
		return window.localStorage.getItem(name);
	};

	function setExpire(name, expire) {
		if (parseFloat(expire) > 0) {
			const expireValue = parseFloat(expire) * 24 * 60 * 60 * 1000 + Date.now();
			const expiresCollection = JSON.parse(window.localStorage.getItem('expiresDates')) || {};
			expiresCollection[name] = expireValue;
			window.localStorage.setItem('expiresDates', JSON.stringify(expiresCollection));
		}
	}

	function setItem(name, value, expire = null) { //parametr expire podawać w dniach (np. 6 oznacza 6 dni od daty utworzenia itemu)
		setExpire(name, expire);
		window.localStorage.setItem(name, value);
	};

	function empty(name) {
		return (getItem(name) === null || getItem(name) === '');
	}
	function removeItem(name) {
		window.localStorage.removeItem(name);
	}

	return {
		getItem,
		setItem,
		removeItem,
		empty
	};
});
